import * as React from "react";
import { useState, useEffect, useMemo } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TableSortLabel,
  Paper,
  Modal,
  Typography,
  CircularProgress,
  Chip,
  IconButton,
  Tooltip,
  TablePagination,
  Button,
  Stack,
  InputAdornment,
  Divider,
  Badge,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SearchIcon from "@mui/icons-material/Search";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import toast from "react-hot-toast";
import UseOnlineStatus from "../../common/UseOnlineStatus";

const token = localStorage.getItem("token");

const vehicleFilterOptions = [
  { label: "Any vehicles", value: "" },
  { label: "With vehicles", value: "with" },
  { label: "Empty groups", value: "without" },
];

const modalStyle = {
  position: "absolute",
  top: "24px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "80%",
  maxWidth: 900,
  maxHeight: "calc(100vh - 48px)",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const emptyNewGroup = {
  name: "",
  code: "",
  cityId: "",
  seatingCapacity: "",
  securityDeposit: "",
};

const headCells = [
  { id: "id", label: "Group ID", numeric: true },
  { id: "name", label: "Name", numeric: false },
  { id: "code", label: "Code", numeric: false },
  { id: "cityId", label: "City", numeric: false },
  { id: "securityDeposit", label: "Security deposit", numeric: true },
  { id: "vehicles", label: "Vehicles", numeric: true },
  { id: "daily", label: "Daily rental packages", numeric: true },
  { id: "subscription", label: "Subscription rental packages", numeric: true },
];

export default function Mysubscription({
  vehicleProfileData,
  setPackageRows,
  packageRows,
  getSubscriptionPAckageDetails,
  loadingGroups,
  setLoadingGroups,
}) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const { isSlowConnection } = UseOnlineStatus();
  const MINIMUM_DAY_COUNT = 7;
  const subscriptionPackages = Array.isArray(packageRows) ? packageRows : [];
  // const [loadingGroups, setLoadingGroups] = useState(false);
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);
  const [packageModal, setPackageModal] = useState({ open: false, kind: null });
  // const [packageRows, setPackageRows] = useState([]);
  const [loadingPackages, setLoadingPackages] = useState(false);

  const [editingPackageId, setEditingPackageId] = useState(null);
  const [packageEditForm, setPackageEditForm] = useState({});
  const [addingPackage, setAddingPackage] = useState(false);
  const [newPackageForm, setNewPackageForm] = useState({});

  useEffect(() => {
    if (isSlowConnection) {
      setEditingPackageId(null);
      setPackageEditForm({});
      setAddingPackage(false);
      setNewPackageForm({});
    }
  }, [isSlowConnection]);

  const authHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `${token}`,
  };

  const getAllHubsList = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubs?limit=1000`);
      const data = await response.json();
      if (data?.statusCode === "0100")
        setGetAllHubsListData(data?.entities?.rows);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    const groupId = vehicleProfileData?.[0]?.vehicleGroupId;
    if (groupId) {
      // getSubscriptionPAckageDetails(groupId);
      getAllHubsList();
    }
  }, [vehicleProfileData?.[0]?.vehicleGroupId]);

  // const getSubscriptionPAckageDetails = async (groupId) => {
  //   setLoadingGroups(true);
  //   try {
  //     let url = `${apiUrl}/api/subscriptionpackages?groupId=${groupId}`;
  //     const response = await fetch(url, {
  //       method: "GET",
  //       headers: authHeaders,
  //     });
  //     const data = await response.json();
  //     if (data?.statusCode === "0100") {
  //       setPackageRows(data?.entities?.rows || []);
  //     } else {
  //       toast.error(
  //         data?.msg || data?.message || "Failed to fetch Subcription packages",
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Subscription packages:", error);
  //     toast.error("Error fetching Subscription packages");
  //   } finally {
  //     setLoadingGroups(false);
  //   }
  // };

  const packagePath = "/api/subscriptionpackages";

  const startEditPackage = (pkg) => {
    if (isSlowConnection) {
      return toast.error("Subscription packages cannot be edited on a slow network");
    }
    if (editingPackageId || addingPackage) return;
    setEditingPackageId(pkg.id);
    setPackageEditForm({ ...pkg });
  };

  const cancelEditPackage = () => {
    setEditingPackageId(null);
    setPackageEditForm({});
  };

  const handlePackageFieldChange = (field, value) => {
    setPackageEditForm((prev) => ({ ...prev, [field]: value }));
  };

  const saveEditPackage = async () => {
    if (isSlowConnection) {
      return toast.error("Subscription packages cannot be edited on a slow network");
    }
    const payload = {
      id: packageEditForm.id,
      packageName: packageEditForm.packageName,
      minDayCount: MINIMUM_DAY_COUNT,
      dailyRateWeekly: Number(packageEditForm.dailyRateWeekly),
      dailyRateFortnightly: Number(packageEditForm.dailyRateFortnightly),
      dailyRateMonthly: Number(packageEditForm.dailyRateMonthly),
      kmPerDayWeekly: Number(packageEditForm.kmPerDayWeekly),
      kmPerDayFortnightly: Number(packageEditForm.kmPerDayFortnightly),
      kmPerDayMonthly: Number(packageEditForm.kmPerDayMonthly),
      extraKmCost: Number(packageEditForm.extraKmCost),
      extraHrCost: 0,
      groupId: vehicleProfileData[0]?.vehicleGroupId,
      cityId: vehicleProfileData[0]?.cityId,
      hubId:
        getAllHubsListData &&
        getAllHubsListData?.find(
          (hub) => hub?.cityId === vehicleProfileData[0]?.cityId,
        )?.id,
    };

    try {
      const response = await fetch(`${apiUrl}${packagePath}`, {
        method: "POST",
        headers: authHeaders,
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Package updated successfully");
        setEditingPackageId(null);
        setAddingPackage(false);
        await getSubscriptionPAckageDetails(
          vehicleProfileData[0]?.vehicleGroupId,
        );
      } else {
        toast.error(data?.msg || data?.message || "Failed to update package");
      }
    } catch (error) {
      toast.error(error?.msg || error?.message);
    }
  };

  const emptyDailyPackageForm = {
    name: "",
    totalFreeKm: "",
    kmPerHr: "",
    costPerKm: "",
    costPerHr: "",
    extraKmCost: "",
    extraHrCost: "",
    weekdayTariff: "",
    weekendTariff: "",
  };

  const emptySubPackageForm = {
    packageName: "",
    minDayCount: "",
    dailyRateWeekly: "",
    dailyRateFortnightly: "",
    dailyRateMonthly: "",
    kmPerDayWeekly: "",
    kmPerDayFortnightly: "",
    kmPerDayMonthly: "",
    extraKmCost: "",
    extraHrCost: "",
  };

  const startAddPackage = () => {
    if (isSlowConnection) {
      return toast.error("Subscription packages cannot be added on a slow network");
    }
    if (editingPackageId || addingPackage) return;
    setNewPackageForm(emptySubPackageForm);
    setAddingPackage(true);
  };

  const cancelAddPackage = () => {
    setAddingPackage(false);
    setNewPackageForm({});
  };

  const handleNewPackageChange = (field, value) => {
    setNewPackageForm((prev) => ({ ...prev, [field]: value }));
  };

  const saveNewPackage = async () => {
    if (isSlowConnection) {
      return toast.error("Subscription packages cannot be added on a slow network");
    }
    if (!newPackageForm.packageName?.trim()) {
      return toast.error("Package name is required");
    }

    const payload = {
      packageName: newPackageForm.packageName,
      minDayCount: MINIMUM_DAY_COUNT,
      dailyRateWeekly: Number(newPackageForm.dailyRateWeekly) || 0,
      dailyRateFortnightly: Number(newPackageForm.dailyRateFortnightly) || 0,
      dailyRateMonthly: Number(newPackageForm.dailyRateMonthly) || 0,
      kmPerDayWeekly: Number(newPackageForm.kmPerDayWeekly) || 0,
      kmPerDayFortnightly: Number(newPackageForm.kmPerDayFortnightly) || 0,
      kmPerDayMonthly: Number(newPackageForm.kmPerDayMonthly) || 0,
      extraKmCost: Number(newPackageForm.extraKmCost) || 0,
      extraHrCost: 0,
      groupId: vehicleProfileData[0]?.vehicleGroupId,
      cityId: vehicleProfileData[0]?.cityId,
      hubId:
        getAllHubsListData &&
        getAllHubsListData?.find(
          (hub) => hub?.cityId === vehicleProfileData[0]?.cityId,
        )?.id,
    };

    try {
      const response = await fetch(`${apiUrl}${packagePath}`, {
        method: "POST",
        headers: authHeaders,
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Package added successfully");
        setAddingPackage(false);
        setEditingPackageId(null);
        await getSubscriptionPAckageDetails(
          vehicleProfileData[0]?.vehicleGroupId,
        );
      } else {
        toast.error(data?.msg || data?.message || "Failed to add package");
      }
    } catch (error) {
      toast.error("Error adding package");
    }
  };

  const countCell = (value, tooltip, onClick) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Typography
        variant="body2"
        sx={{
          fontVariantNumeric: "tabular-nums",
          color: value ? "text.primary" : "text.disabled",
        }}
      >
        {value}
      </Typography>
      <Tooltip title={tooltip}>
        <IconButton size="small" onClick={onClick}>
          <InfoOutlinedIcon sx={{ fontSize: 17 }} color="primary" />
        </IconButton>
      </Tooltip>
    </Box>
  );

  return (
    <div className="p-6">
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <div className="flex gap-2">
            <div className="h-5 w-1 rounded bg-teal-600"></div>
            <h2 className="text-lg font-semibold text-slate-800">
              My Subscription package
            </h2>
          </div>
          {isSlowConnection ? (
            <Typography variant="body2" color="warning.main">
              Slow network detected. Adding and editing packages are unavailable.
            </Typography>
          ) : vehicleProfileData &&
            vehicleProfileData[0]?.vehicleGroupId !== 0 &&
            vehicleProfileData[0]?.vehicleGroupId !== null && (
              <Stack direction="row" spacing={1} alignItems="center">
                {packageRows?.length > 0 ? (
                  <></>
                ) : (
                  <Button variant="contained" onClick={startAddPackage}>
                    Add Subscription package
                  </Button>
                )}
              </Stack>
            )}
        </Box>

        {loadingPackages ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress size={28} />
          </Box>
        ) : subscriptionPackages?.length === 0 && !addingPackage ? (
          <Typography variant="body2" color="text.secondary">
            No packages found for this group.
          </Typography>
        ) : (
          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ borderRadius: 2, mt: 4 }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ bgcolor: "#f5f7fa" }} />
                  <TableCell sx={{ bgcolor: "#f5f7fa" }} />
                  <TableCell sx={{ bgcolor: "#f5f7fa" }} />
                  <TableCell
                    colSpan={3}
                    align="center"
                    sx={{
                      bgcolor: "#fff",
                      color: "#000",
                      fontWeight: 700,
                      border: "2.5px solid #000",
                    }}
                  >
                    Price per day
                  </TableCell>
                  <TableCell
                    colSpan={3}
                    align="center"
                    sx={{
                      bgcolor: "#fff",
                      color: "#000",
                      fontWeight: 700,
                      border: "2.5px solid #000",
                    }}
                  >
                    KM per day
                  </TableCell>
                  <TableCell
                    colSpan={2}
                    align="center"
                    sx={{
                      bgcolor: "#fff",
                      color: "#000",
                      fontWeight: 700,
                      border: "2.5px solid #000",
                    }}
                  >
                    Extra Charges per day
                  </TableCell>
                </TableRow>
                <TableRow sx={{ bgcolor: "#f5f7fa" }}>
                  <TableCell sx={{ fontWeight: 700 }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Min days</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>7 Days</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>15 Days</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>30 Days</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>7 Days</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>15 Days</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>30 Days</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Per Km</TableCell>
                  {/* <TableCell sx={{ fontWeight: 700 }}>Per Hr</TableCell> */}
                  {!isSlowConnection && (
                    <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {addingPackage && !isSlowConnection && (
                  <TableRow>
                    <TableCell>-</TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        value={newPackageForm.packageName ?? ""}
                        onChange={(e) =>
                          handleNewPackageChange("packageName", e.target.value)
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        type="number"
                        disabled={true}
                        value={MINIMUM_DAY_COUNT}
                        //   onChange={(e) =>
                        //     handleNewPackageChange("minDayCount", e.target.value)
                        //   }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        type="number"
                        value={newPackageForm.dailyRateWeekly ?? ""}
                        onChange={(e) =>
                          handleNewPackageChange(
                            "dailyRateWeekly",
                            e.target.value,
                          )
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        type="number"
                        value={newPackageForm.dailyRateFortnightly ?? ""}
                        onChange={(e) =>
                          handleNewPackageChange(
                            "dailyRateFortnightly",
                            e.target.value,
                          )
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        type="number"
                        value={newPackageForm.dailyRateMonthly ?? ""}
                        onChange={(e) =>
                          handleNewPackageChange(
                            "dailyRateMonthly",
                            e.target.value,
                          )
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        type="number"
                        value={newPackageForm.kmPerDayWeekly ?? ""}
                        onChange={(e) =>
                          handleNewPackageChange(
                            "kmPerDayWeekly",
                            e.target.value,
                          )
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        type="number"
                        value={newPackageForm.kmPerDayFortnightly ?? ""}
                        onChange={(e) =>
                          handleNewPackageChange(
                            "kmPerDayFortnightly",
                            e.target.value,
                          )
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        type="number"
                        value={newPackageForm.kmPerDayMonthly ?? ""}
                        onChange={(e) =>
                          handleNewPackageChange(
                            "kmPerDayMonthly",
                            e.target.value,
                          )
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        type="number"
                        value={newPackageForm.extraKmCost ?? ""}
                        onChange={(e) =>
                          handleNewPackageChange("extraKmCost", e.target.value)
                        }
                      />
                    </TableCell>
                    {/* <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      value={newPackageForm.extraHrCost ?? ""}
                      onChange={(e) =>
                        handleNewPackageChange("extraHrCost", e.target.value)
                      }
                    />
                  </TableCell> */}
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={saveNewPackage}
                        >
                          Save
                        </Button>
                        <Button size="small" onClick={cancelAddPackage}>
                          Cancel
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                )}
                {subscriptionPackages.map((p) => {
                  const isEditing = !isSlowConnection && editingPackageId === p.id;
                  return (
                    <TableRow key={p.id} hover>
                      <TableCell>{p.id}</TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            size="small"
                            value={packageEditForm.packageName ?? ""}
                            onChange={(e) =>
                              handlePackageFieldChange(
                                "packageName",
                                e.target.value,
                              )
                            }
                          />
                        ) : (
                          p.packageName || "-"
                        )}
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            size="small"
                            type="number"
                            disabled={true}
                            value={MINIMUM_DAY_COUNT}
                            //   onChange={(e) =>
                            //     handlePackageFieldChange(
                            //       "minDayCount",
                            //       e.target.value,
                            //     )
                            //   }
                          />
                        ) : (
                          (p.minDayCount ?? "-")
                        )}
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            size="small"
                            type="number"
                            value={packageEditForm.dailyRateWeekly ?? ""}
                            onChange={(e) =>
                              handlePackageFieldChange(
                                "dailyRateWeekly",
                                e.target.value,
                              )
                            }
                          />
                        ) : (
                          (p.dailyRateWeekly ?? "-")
                        )}
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            size="small"
                            type="number"
                            value={packageEditForm.dailyRateFortnightly ?? ""}
                            onChange={(e) =>
                              handlePackageFieldChange(
                                "dailyRateFortnightly",
                                e.target.value,
                              )
                            }
                          />
                        ) : (
                          (p.dailyRateFortnightly ?? "-")
                        )}
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            size="small"
                            type="number"
                            value={packageEditForm.dailyRateMonthly ?? ""}
                            onChange={(e) =>
                              handlePackageFieldChange(
                                "dailyRateMonthly",
                                e.target.value,
                              )
                            }
                          />
                        ) : (
                          (p.dailyRateMonthly ?? "-")
                        )}
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            size="small"
                            type="number"
                            value={packageEditForm.kmPerDayWeekly ?? ""}
                            onChange={(e) =>
                              handlePackageFieldChange(
                                "kmPerDayWeekly",
                                e.target.value,
                              )
                            }
                          />
                        ) : (
                          (p.kmPerDayWeekly ?? "-")
                        )}
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            size="small"
                            type="number"
                            value={packageEditForm.kmPerDayFortnightly ?? ""}
                            onChange={(e) =>
                              handlePackageFieldChange(
                                "kmPerDayFortnightly",
                                e.target.value,
                              )
                            }
                          />
                        ) : (
                          (p.kmPerDayFortnightly ?? "-")
                        )}
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            size="small"
                            type="number"
                            value={packageEditForm.kmPerDayMonthly ?? ""}
                            onChange={(e) =>
                              handlePackageFieldChange(
                                "kmPerDayMonthly",
                                e.target.value,
                              )
                            }
                          />
                        ) : (
                          (p.kmPerDayMonthly ?? "-")
                        )}
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            size="small"
                            type="number"
                            value={packageEditForm.extraKmCost ?? ""}
                            onChange={(e) =>
                              handlePackageFieldChange(
                                "extraKmCost",
                                e.target.value,
                              )
                            }
                          />
                        ) : (
                          (p.extraKmCost ?? "-")
                        )}
                      </TableCell>
                      {/* <TableCell>
                      {isEditing ? (
                        <TextField
                          size="small"
                          type="number"
                          value={packageEditForm.extraHrCost ?? ""}
                          onChange={(e) =>
                            handlePackageFieldChange(
                              "extraHrCost",
                              e.target.value,
                            )
                          }
                        />
                      ) : (
                        (p.extraHrCost ?? "-")
                      )}
                    </TableCell> */}
                      {!isSlowConnection && (
                        <TableCell>
                          {isEditing ? (
                            <Stack direction="row" spacing={1}>
                              <Button
                                size="small"
                                variant="contained"
                                onClick={saveEditPackage}
                              >
                                Save
                              </Button>
                              <Button size="small" onClick={cancelEditPackage}>
                                Cancel
                              </Button>
                            </Stack>
                          ) : (
                            <Button
                              size="small"
                              disabled={
                                addingPackage ||
                                (editingPackageId && editingPackageId !== p.id)
                              }
                              onClick={() => startEditPackage(p)}
                            >
                              Edit
                            </Button>
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </div>
  );
}
